'use client';

import { skipToken, useSuspenseQuery } from '@apollo/client';
import {
    GetLocationFeatureFlagsQuery,
    GetLocationFeatureFlagsQueryVariables,
    LocationFeaturesFragmentFragment,
    GET_LOCATION_FEATURE_FLAGS_QUERY,
    getFragmentData,
    LOCATION_FEATURES_FRAGMENT,
} from '@deltasierra/frontend-graphql-core';

export function useLocationFeatures(locationId: string | null): {
    locationFeatureFlags: LocationFeaturesFragmentFragment | null;
} {
    const { data } = useSuspenseQuery<GetLocationFeatureFlagsQuery, GetLocationFeatureFlagsQueryVariables>(
        GET_LOCATION_FEATURE_FLAGS_QUERY,
        locationId ? { variables: { locationId } } : skipToken,
    );
    return { locationFeatureFlags: getFragmentData(LOCATION_FEATURES_FRAGMENT, data?.location?.features) ?? null };
}
